import { useMapEvents } from 'react-leaflet';

function MapEvents({ setWaypoints, setMyPosition }) {
  
  const map = useMapEvents({
    // This runs when the user clicks on the map
    click(e) {
      const { lat, lng } = e.latlng;
      
      // --- THIS IS THE CHANGE ---
      // Instead of an array, we add an object
      const newWaypoint = {
        lat: lat,
        lng: lng,
        name: 'Custom Waypoint' // This is the name for a random map click
      };
      setWaypoints((prevWaypoints) => [...prevWaypoints, newWaypoint]);
      // --- END OF CHANGE ---
    },
    
    // This runs when the map finds the user's location
    locationfound(e) {
      setMyPosition(e.latlng); // This is an object { lat, lng }
      map.flyTo(e.latlng, 14); 
    }
  });

  return null; // This component doesn't render any visible HTML
}

export default MapEvents;